import { render } from "./PaymentProcessingPage.vue?vue&type=template&id=38fdc824"
import script from "./PaymentProcessingPage.vue?vue&type=script&lang=js"
export * from "./PaymentProcessingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__